export default "__VITE_ASSET__CkoZJ$f1__"